import { ReactNode } from 'react';

import {
  ApiCaseMemberResponseV2,
  ApiCaseResponseV2,
  ApiGrantRoleDto,
  ApiParticipantResponse,
  ApiTaskResponseV2,
  ApiUpdateCaseMemberSelfDtoV2,
} from '@/shared/api';

import { FilterUserStatus } from '../components/SelectVfoStatus';

export const UserStatus = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
} as const satisfies Record<ApiParticipantResponse['status'], ApiParticipantResponse['status']>;

export type UserStatus = (typeof UserStatus)[keyof typeof UserStatus];

export const Tags = {
  FAMILY: 'FAMILY',
  LEGAL: 'LEGAL',
  WEALTH: 'WEALTH',
  TAX: 'TAX',
  FINANCE: 'FINANCE',
  MANAGEMENT: 'MANAGEMENT',
  LIFESTYLE: 'LIFESTYLE',
} as const satisfies Record<
  NonNullable<ApiCaseMemberResponseV2['tagCode']>,
  ApiCaseMemberResponseV2['tagCode']
>;

export type Tags = (typeof Tags)[keyof typeof Tags];

export const ActivationStatus = {
  ACTIVE: 'ACTIVE',
  INVITED: 'INVITED',
  PENDING: 'PENDING',
} as const;

export type ActivationStatus = (typeof ActivationStatus)[keyof typeof ActivationStatus];

export type Member = {
  profileId?: number;
  createdAt?: string;
  firstName?: string;
  lastName?: string;
  email: string;
  tag?: Tags;
  country?: ApiUpdateCaseMemberSelfDtoV2['country'];
  status: UserStatus;
  activationStatus: ActivationStatus;
  lastActiveDate?: string;
  isFounder?: boolean;
  invitationId?: string;
  scopeId?: number;
  accessLevel?: AccessLevel;
};

export enum EntityType {
  Member = 'member',
  File = 'file',
}

export type VfoModalCommon = {
  title: string;
  subTitle?: ReactNode;
} & (
  | {
      type: 'case';
      caseData?: ApiCaseResponseV2;
    }
  | {
      type: 'member';
      member: Member;
    }
);

export const TaskStatus = {
  TODO: 'TODO',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
  CANCELLED: 'CANCELLED',
} as const satisfies Record<ApiTaskResponseV2['status'], ApiTaskResponseV2['status']>;

export type TaskStatus = (typeof TaskStatus)[keyof typeof TaskStatus];

export const TaskPriority = {
  URGENT: 'URGENT',
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW',
} as const satisfies Record<ApiTaskResponseV2['priority'], ApiTaskResponseV2['priority']>;

export type TaskPriority = (typeof TaskPriority)[keyof typeof TaskPriority];

export const AccessLevel = {
  BASIC: 'BASIC',
  CONNECTED: 'CONNECTED',
  DELEGATED: 'DELEGATED',
  EXECUTIVE: 'EXECUTIVE',
} as const satisfies Record<ApiGrantRoleDto['roleCode'], ApiGrantRoleDto['roleCode']>;

export type AccessLevel = (typeof AccessLevel)[keyof typeof AccessLevel];

export type MembersFilters = {
  statusesFilter: FilterUserStatus[];
  tagsFilter: Tags[];
  casesFilter: string[];
};

export enum FileFilter {
  PDF = 'pdf',
  SPREADSHEET = 'spreadsheet',
  IMAGE = 'image',
  TEXT_DOCUMENT = 'text-document',
}

export type DocumentsFilters = {
  fileTypeFilters: FileFilter[];
  casesFilter: string[];
};
